import { Controller } from "@hotwired/stimulus"
import { money, percent, read } from "../../lib/format"

// Gross, operating and net margin from revenue and three layers of cost.
export default class extends Controller {
  static targets = ["revenue", "cogs", "opex", "tax", "gross", "operating", "net"]

  connect() { this.compute() }

  compute() {
    const revenue = read(this.revenueTarget)
    const gross = revenue - read(this.cogsTarget)
    const operating = gross - read(this.opexTarget)
    const net = operating - read(this.taxTarget)

    this.show(this.grossTarget, gross, revenue)
    this.show(this.operatingTarget, operating, revenue)
    this.show(this.netTarget, net, revenue)
  }

  show(target, profit, revenue) {
    const margin = revenue > 0 ? profit / revenue : NaN
    target.innerHTML = `${percent(margin)} <small>${money(profit)}</small>`
    target.classList.toggle("warn", Number.isFinite(margin) && margin < 0)
  }
}
